import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice, getEffectivePrice, getDiscount } from '../../utils/helpers';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const effectivePrice = getEffectivePrice(product);
  const discount = getDiscount(product);

  return (
    <Link to={`/products/${product._id}`} className="product-card">
      <div className="product-img-wrap">
        <img
          src={product.thumbnail || 'https://via.placeholder.com/300x300?text=NORIX'}
          alt={product.name}
          className="product-img"
        />
        {discount > 0 && (
          <div className="discount-badge">-{discount}%</div>
        )}
        {product.salePrice && (
          <div className="sale-badge">SALE</div>
        )}
        <div className="product-overlay">
          <span>View Product →</span>
        </div>
      </div>

      <div className="product-info">
        <span className="product-cat">{product.category}</span>
        <h3 className="product-name">{product.name}</h3>

        <div className="product-stars">
          {'★'.repeat(Math.round(product.rating || 0))}{'☆'.repeat(5 - Math.round(product.rating || 0))}
          <span className="review-count">({product.numReviews || 0})</span>
        </div>

        <div className="product-price-row">
          <span className="product-price">{formatPrice(effectivePrice)}</span>
          {effectivePrice < product.price && (
            <span className="product-original">{formatPrice(product.price)}</span>
          )}
        </div>

        <div className="size-dots">
          {product.sizes?.filter(s => s.available || s.preOrder).map(s => (
            <span key={s.label} className={`size-dot ${s.preOrder && !s.available ? 'preorder' : ''}`}>
              {s.label}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
